import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MailIcon, LockIcon, UserIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const {
    login,
    register
  } = useAuth();
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError('');
  };
  const validateForm = () => {
    if (!formData.email || !formData.password) {
      setError('Please fill in all required fields');
      return false;
    }
    if (!isLogin && formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return false;
    }
    if (!isLogin && !formData.name) {
      setError('Please enter your name');
      return false;
    }
    return true;
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsSubmitting(true);
    setError('');
    try {
      if (isLogin) {
        // Simulate login API call
        setTimeout(() => {
          const success = login(formData.email, formData.password);
          if (success) {
            navigate('/');
          } else {
            setError('Invalid email or password');
            setIsSubmitting(false);
          }
        }, 1000);
      } else {
        // Simulate registration API call
        setTimeout(() => {
          const success = register(formData.name, formData.email, formData.password);
          if (success) {
            navigate('/');
          } else {
            setError('Email already in use');
            setIsSubmitting(false);
          }
        }, 1000);
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
      setIsSubmitting(false);
    }
  };
  return <div className="bg-[#F8F5F0] min-h-screen w-full py-12" data-id="element-783">
      <div className="container mx-auto px-4" data-id="element-784">
        <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-8" data-id="element-785">
          <h1 className="text-2xl font-bold text-[#333333] mb-6 text-center" data-id="element-786">
            {isLogin ? 'Sign In to Your Account' : 'Create an Account'}
          </h1>
          {error && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4" data-id="element-787">
              {error}
            </div>}
          <form onSubmit={handleSubmit} data-id="element-788">
            {!isLogin && <div className="mb-4" data-id="element-789">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-790">
                  Full Name
                </label>
                <div className="relative" data-id="element-791">
                  <UserIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-792" />
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="pl-10 w-full p-3 border border-gray-300 rounded-md focus:ring-[#D4A017] focus:border-[#D4A017] outline-none" placeholder="John Doe" data-id="element-793" />
                </div>
              </div>}
            <div className="mb-4" data-id="element-794">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-795">
                Email Address
              </label>
              <div className="relative" data-id="element-796">
                <MailIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-797" />
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="pl-10 w-full p-3 border border-gray-300 rounded-md focus:ring-[#D4A017] focus:border-[#D4A017] outline-none" placeholder="john.doe@example.com" data-id="element-798" />
              </div>
            </div>
            <div className="mb-4" data-id="element-799">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-800">
                Password
              </label>
              <div className="relative" data-id="element-801">
                <LockIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-802" />
                <input type={showPassword ? 'text' : 'password'} id="password" name="password" value={formData.password} onChange={handleChange} className="pl-10 pr-10 w-full p-3 border border-gray-300 rounded-md focus:ring-[#D4A017] focus:border-[#D4A017] outline-none" placeholder="••••••••" data-id="element-803" />
                <button type="button" className="absolute right-3 top-1/2 transform -translate-y-1/2" onClick={() => setShowPassword(!showPassword)} data-id="element-804">
                  {showPassword ? <EyeOffIcon className="h-5 w-5 text-gray-400" data-id="element-805" /> : <EyeIcon className="h-5 w-5 text-gray-400" data-id="element-806" />}
                </button>
              </div>
            </div>
            {!isLogin && <div className="mb-4" data-id="element-807">
                <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-808">
                  Confirm Password
                </label>
                <div className="relative" data-id="element-809">
                  <LockIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-810" />
                  <input type={showPassword ? 'text' : 'password'} id="confirmPassword" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} className="pl-10 w-full p-3 border border-gray-300 rounded-md focus:ring-[#D4A017] focus:border-[#D4A017] outline-none" placeholder="••••••••" data-id="element-811" />
                </div>
              </div>}
            {isLogin && <div className="flex justify-end mb-4" data-id="element-812">
                <a href="#" className="text-sm text-[#006D77] hover:underline" data-id="element-813">
                  Forgot password?
                </a>
              </div>}
            <button type="submit" disabled={isSubmitting} className={`w-full bg-[#006D77] hover:bg-[#00595f] text-white py-3 rounded-md font-medium mb-4 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`} data-id="element-814">
              {isSubmitting ? <span className="flex items-center justify-center" data-id="element-815">
                  <span className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white mr-2" data-id="element-816"></span>
                  {isLogin ? 'Signing In...' : 'Creating Account...'}
                </span> : isLogin ? 'Sign In' : 'Create Account'}
            </button>
            <div className="text-center" data-id="element-817">
              <button type="button" onClick={() => {
              setIsLogin(!isLogin);
              setError('');
              setFormData({
                name: '',
                email: '',
                password: '',
                confirmPassword: ''
              });
            }} className="text-[#006D77] hover:underline" data-id="element-818">
                {isLogin ? "Don't have an account? Sign Up" : 'Already have an account? Sign In'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
};
export default AuthPage;